import React from 'react';
// import './login.css';
import { Link, useNavigate } from 'react-router-dom';
import { Field, reduxForm, getFormSyncErrors } from 'redux-form';
import axios from 'axios';
import moment from 'moment';
import { useSelector, connect, useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import TwitterLogin from 'react-twitter-auth';
import { GoogleLogin } from 'react-google-login';
import config from '../../config.json';
import {
	CButton, CInput, CCol,
} from 'compat/coreui';
import { getData } from '../../helpers/api';

const required = (value) => (value ? undefined : "Required");

const email = (value) =>
	value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
		? "Invalid email address"
		: undefined;

const renderField = ({ input, label, type, meta: { touched, error, warning } }) => (
	<React.Fragment>
		<input {...input} placeholder={label} type={type} className="login_input" />
		{touched && ((error && <span className="text-red">{error}</span>) || (warning && <span>{warning}</span>))}
	</React.Fragment>
)




function Login(props) {
	const { handleSubmit, reset } = props;
	const values = useSelector(state => state.form.loginForm && state.form.loginForm.values)
	const dispatch = useDispatch()
	const navigate = useNavigate()

	function responseFacebook(response) {
		const tokenBlob = new Blob([JSON.stringify({ access_token: response.accessToken }, null, 2)], { type: 'application/json' });
		console.log("=========>>> ", response);
		const options = {
			method: 'POST',
			body: {
				name: response.name,
				id: response.id,
				accessToken: response.accessToken,
				data_access_expiration_time: response.data_access_expiration_time,
				expiresIn: response.expiresIn,
				signedRequest: response.signedRequest,
				userID: response.userID
			},
			//  mode: 'cors',
			//  cache: 'default'
		};
		console.log("--------", options);
		const data = {
			name: response.name,
			id: response.id,
			accessToken: response.accessToken,
			data_access_expiration_time: response.data_access_expiration_time,
			expiresIn: response.expiresIn,
			signedRequest: response.signedRequest,
			userID: response.userID
		}
		axios({
			url: `${process.env.REACT_APP_APP_API_URL}/api/auth/facebook`,
			method: 'POST',
			data
		}).then(r => {
			console.log("EEEEEEEEEEEEEEE", r);
			// this.setState({isAuthenticated: true});
			// this.openLoginModal();
			let user = r.data;
			console.log("_------------>>>. ", user);
			if (user.status) {
				toast.success("Login Successful!");
				const token = user.user.accessToken
				localStorage.setItem('token', token)
				getData(`${process.env.REACT_APP_APP_API_URL}/api/user`).then(res => {
					res.data.user.token = token
					dispatch({
						type: 'LOGIN_USER',
						user: res.data.user
					});
					dispatch({
						type: 'USER_ORDERS',
						orders: res.data.orders
					});
					if (res.data.user.role === 'SELLER') {
						navigate('/dashboard');
					} else {
						navigate('/profile');
					}
				}).catch(console.log)
			} else {
				toast.error(user.message);
			}
		})
	}

	const twitterResponse = (response) => {
		if (response) {
			const token = response.headers.get('x-auth-token');
			response.json().then(user => {

				if (token) {
					navigate('/profile')
					// this.setState({isAuthenticated: true, user, token});
				}
			});
		}
	};

	const googleResponse = (response) => {
		const tokenBlob = new Blob([JSON.stringify({ access_token: response.accessToken }, null, 2)], { type: 'application/json' });
		const options = {
			method: 'POST',
			body: { access_token: response.accessToken },
			//  mode: 'cors',
			//  cache: 'default'
		};
		fetch(`${process.env.REACT_APP_APP_API_URL}/api/auth/google`, options).then(r => {
			const token = r.headers.get('x-auth-token');
			// this.setState({isAuthenticated: true});
			// this.openLoginModal();
			r.json().then(user => {
				if (user.status) {
					toast.success("Login Successful!");
					const token = user.user.accessToken
					localStorage.setItem('token', token)
					getData(`${process.env.REACT_APP_APP_API_URL}/api/user`).then(res => {
						res.data.user.token = token
						dispatch({
							type: 'LOGIN_USER',
							user: res.data.user
						});
						dispatch({
							type: 'USER_ORDERS',
							orders: res.data.orders
						});
						if (res.data.user.role === 'SELLER') {
							navigate('/dashboard');
						} else {
							navigate('/profile');
						}
					}).catch(console.log)
				} else {
					toast.error(user.message);
				}
			});
		})

	};

	function submit(e) {
		e.preventDefault()
		if (!props.valid) {
			props.touch("email");
			props.touch("password");
		} else {
			axios.post(`${process.env.REACT_APP_APP_API_URL}/api/auth/login`, {
				"email": values.email,
				"password": values.password,
			}).then(response => {
				if (response.status === 200) {
					if (response.data.status == 200) {
						toast.success("Login Successful!");
						const token = response.data.token
						localStorage.setItem('token', token)
						getData(`${process.env.REACT_APP_APP_API_URL}/api/user`).then(res => {
							res.data.user.token = token
							dispatch({
								type: 'LOGIN_USER',
								user: res.data.user
							});
							dispatch({
								type: 'USER_ORDERS',
								orders: res.data.orders
							});
							if (res.data.user.role === 'SELLER') {
								navigate('/dashboard');
							} else {
								navigate('/profile');
							}
						}).catch(console.log)
					} else {
						toast.error(response.data.message);
					}
				}
			}).catch(e => {
				if (e && e.response && e.response.data.message) {
					toast.error(e.response.data.message);
				}
			})
		}
	}

	return (
		<React.Fragment>
			<div className="login-page_login-wrapper">
				<div className="login_page clearfix">
					<div>
						<h1 style={{ textAlign: "center" }}>Login with Social Media or Manually</h1>
						<div className="vl">
							<span className="vl-innertext">or</span>
						</div>
						<div className="col-lg-6">
							<FacebookLogin
								appId={config.FACEBOOK_APP_ID}
								callback={responseFacebook}
								render={renderProps => (
									<span className="login_fb socialbtn" onClick={renderProps.onClick}>
										<i className="fa fa-facebook fa-fw"></i> Login with Facebook
									</span>
									/*<a   onClick={renderProps.onClick} className="google btn mybtn"><i className="fa fa-facebook-square">
									</i> Signin using Facebook
									</a>*/
								)}
							/>
							<TwitterLogin
								loginUrl={`${process.env.REACT_APP_APP_API_URL}/api/auth/twitter`}
								onFailure={() => { }}
								onSuccess={twitterResponse}
								requestTokenUrl={`${process.env.REACT_APP_APP_API_URL}/api/auth/twitter/reverse`}
								className="login_twitter socialbtn"
							>
								<i className="fa fa-twitter fa-fw"></i> Login with Twitter
								</TwitterLogin>

							<GoogleLogin
								clientId={config.GOOGLE_CLIENT_ID}
								onSuccess={googleResponse}
								onFailure={googleResponse}
								className="socialbtn googlebtn"
							>
								<i className="fa fa-google fa-fw"></i> Login with Google+
								</GoogleLogin>
						</div>
						<div className="col-md-6 login-page__manual-login pb-5">
							<div className="hide-md-lg">
								<p>Or sign in manually:</p>
							</div>
							<form onSubmit={submit}>
								<Field name="email" component={renderField} type="email" validate={[required, email]} />
								<Field name="password" component={renderField} type="password" validate={[required]} />
								<CButton className="my-2 my-sm-0 login_input" style={{ marginBottom: '40px!important' }} color="success" type="submit">Submit</CButton>
							</form>
						</div>
					</div>
					<div className="row login-page__bottom-container">
						<div className="col-lg-6 login-page__bottom-button1">
							<CButton className="login_input" color="success" onClick={() => { navigate('/signup') }}>Signup</CButton>
						</div>
						<div className="col-lg-6 login-page__bottom-button2 text-center mt-2">
							<CButton className="my-2 my-sm-0 login_input text-white" color="warning" onClick={() => { navigate('/') }}>Forgot password?</CButton>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
}



let MainReduxForm = reduxForm({
	form: 'loginForm',
	destroyOnUnmount: true
})(Login)

export default MainReduxForm = connect((state) => ({
	synchronousError: getFormSyncErrors("loginForm")(state),
}))(MainReduxForm);
